import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export default function ConfirmModal({action,name, onConfirm,disabled,variant}) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
    <Button variant={ variant} onClick={handleShow}               disabled={disabled}>
        {action}
      </Button>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{action} plan <strong>{name}</strong></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you want to {action} ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="primary" onClick={()=>{onConfirm();handleClose()}}>Yes</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
